import React, { useEffect, useState } from 'react';
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import './SubCostCenterMaster.css'; // Assuming you have a CSS file for styles

const SubCostCenterMaster = () => {
  const [costCenters, setCostCenters] = useState([]);
  const [selectedCostCenter, setSelectedCostCenter] = useState('');
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [costCenterData, setCostCenterData] = useState({
    sub_cost_center_name: "",
  });
  const [message, setMessage] = useState('');

  const baseAPI = process.env.REACT_APP_API_URL;

  const fetchCostCenters = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        `${baseAPI}adminget/GetSubCostCenter?sub_cost_center_id=0&cost_center_id=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const allCenters = response.data?.data;
      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter((item) => item.is_active === true);
        setCostCenters(activeCenters);
      } else {
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch Sub Cost Centers.");
    }
  };

  const fetchCostCenterOptions = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        `${baseAPI}adminget/GetCostCenter?cost_center_id=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const allCenters = response.data?.data;
      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter((item) => item.is_active === true);
        setCostCenterOptions(activeCenters);
      } else {
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch Cost Centers.");
    }
  };

  useEffect(() => {
    fetchCostCenters();
    fetchCostCenterOptions();
  }, []);

  const handleSubmit = async () => {
    if (!costCenterData.sub_cost_center_name.trim()) {
      alert("Please enter Sub Cost Center name.");
      return;
    }

    if (!selectedCostCenter) {
      alert("Please select a Cost Center.");
      return;
    }

    const payload = {
      sub_cost_center_name: costCenterData.sub_cost_center_name.trim(),
      cost_center_id: parseInt(selectedCostCenter, 10),
    };

    console.log("Submitting payload:", payload); // ✅ Debug log

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      const response = await axios.post(
        `${baseAPI}adminPost/AddSubConstCenter`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        alert("Sub Cost Center added successfully!");
        setCostCenterData({ sub_cost_center_name: "" });
        setSelectedCostCenter("");
        fetchCostCenters();
      } else {
        alert("Failed to add Sub Cost Center.");
      }
    } catch (error) {
      console.error("Error adding Sub Cost Center:", error);
      alert(`Error: ${error.response?.data?.message || "Unexpected error"}`);
    }
  };

  // Delete cost center (soft delete)
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this cost center?")) return;

  try {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const response = await axios.post(
      `${baseAPI}adminPost/DeleteSubConstCenter`,
      { sub_cost_center_id: id.toString() },
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Delete response:", response);

    if (response.status === 200 || response.status === 204) {
      alert("Cost center deleted successfully.");
      fetchCostCenters();
    } else {
      alert("Failed to delete cost center.");
    }
  } catch (error) {
    console.error("Delete error:", error.response || error);
    alert(`Error: ${error.response?.data?.message || "Something went wrong."}`);
  }
};



  const handleChange = (e) => {
    setCostCenterData({
      ...costCenterData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div className="container-fluid" style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}>
        <div className="d-flex flex-column w-100" style={{ backgroundColor: "#F4F4F4" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Sub Cost Center | <HomeOutlinedIcon /> <span style={{ fontSize: "20px" }}>&gt; Master</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA</option>
                <option value="1">DUBAI</option>
              </select>
            </div>
          </div>


          <Wrapper className="ViewLeadDetails mb-2">
            <div className='row'>
  <div className='col-4'>
<div className="form-group mb-3">
              <label>Sub Cost Center Name:</label>
              <input
                type="text"
                className="form-control"
                name="sub_cost_center_name"
                value={costCenterData.sub_cost_center_name}
                onChange={handleChange}
                placeholder="Enter name"
              />
            </div>
  </div>
  <div className='col-4'>
<div className="form-group mb-3">
              <label>Select Cost Center:</label>
              <select
                className="form-control"
                value={selectedCostCenter}
                onChange={(e) => setSelectedCostCenter(e.target.value)}
              >
                <option value="">-- Select --</option>
                {costCenterOptions.map((cc) => (
                  <option key={cc.cost_center_id} value={cc.cost_center_id}>
                    {cc.cost_center_name}
                  </option>
                ))}
              </select>
            </div>
  </div>
  <div className='col-4'>
    <div className="form-group mb-3 text-end">
       <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
    </div>
                </div>
</div>
           
</Wrapper>
<Wrapper className="ViewLeadDetails">
            {message && <p className="mt-3">{message}</p>}

            <h5 className="mt-4">Sub Cost Center List</h5>
            <table className="table table-bordered">
              <thead className='SubCostCenterMaster-thead'>
                <tr>
                  <th>S.NO</th>
                  <th>Sub Cost Center Name</th>
                  <th>Cost Center Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className='SubCostCenterMaster-tbody'>
                {Array.isArray(costCenters) && costCenters.length > 0 ? (
                  costCenters.map((center, index) => (
                    <tr key={center.sub_cost_center_id || index}>
                      <td>{index + 1}</td>
                      <td>{center.sub_cost_center_name}</td>
                      <td>{center.cost_center_name}</td>
                      <td className='SubCostCenterMaster-td4'>
                        <button
                          className="btn btn-link text-danger p-0"
                          onClick={() => handleDelete(center.sub_cost_center_id)}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Wrapper>
        </div>
      </div>
    </div>
  );
};
export default SubCostCenterMaster;

